export const diff = (before, after) => {
  if (before === after) {
    return { original: '', position: -1, replace: '' };
  }

  var shorter = before;
  var longer = after;

  if (before.length > after.length) {
    shorter = after;
    longer = before;
  }

  for (var i = 0; i < shorter.length; i++) {
    if (longer[i] !== shorter[i]) {
      break;
    }
  }

  const longLen = longer.length;
  const shortLen = shorter.length;
  for (var j = 1; j <= shorter.length && shortLen - j >= i; j++) {
    if (longer[longLen - j] !== shorter[shortLen - j]) {
      break;
    }
  }

  var position = i;
  var original = shorter.slice(i, shortLen - j + 1);
  var replace = longer.slice(i, longLen - j + 1);
  if (before.length > after.length) {
    replace = shorter.slice(i, shortLen - j + 1);
    original = longer.slice(i, longLen - j + 1);
  }

  return { position, original, replace };
};

export const truncateMessage = (message, maxLength = 40) => {
  if (message.length > maxLength) {
    return message.slice(0, maxLength) + '...';
  }
  return message;
};

export const getIPFSLink = (hash) => {
  return `https://ipfs.io/ipfs/${hash}`;
};

export const getEtherscanLink = (chainId, address) => {
  const chainMap = {
    1: '',
    5: 'goerli.',
  };

  return `https://${
    chainMap[parseInt(chainId)]
  }etherscan.io/address/${address}`;
};

export const getOpenSeaLink = ({ chainId, contract, _nftId }) => {
  if (parseInt(chainId) === 1)
    return `https://opensea.io/assets/ethereum/${contract}/${_nftId}`;
  if (parseInt(chainId) === 5)
    return `https://testnets.opensea.io/assets/goerli/${contract}/${_nftId}`;
};
